module.exports = __webpack_public_path__ + "static/media/bg-campaign-hero-01-mobile.0de3c756.jpg";